var LFCFG=JSON.parse((document.getElementById('lf-cfg-main-product-0')||{textContent:'{}'}).textContent);

(function(){
  var CSS = ""
    /* VIKTOR-SKIO-FIX v2: radio centred on the title line, pill inline-right on desktop,
       stacked above on mobile where it cannot fit, frequency line left-aligned below. */
    + ".group-topline{align-items:center!important;}"
    + ".skio-radio__container{align-self:center!important;flex:0 0 auto!important;}"
    + ".group-title{display:flex!important;align-items:center!important;text-align:left!important;min-width:0!important;}"
    + ".group-title .savings.bubble{flex:0 0 auto!important;white-space:nowrap!important;}"
    + "@media (min-width:769px){"
    +   ".group-title{flex-direction:row!important;gap:10px!important;}"
    +   ".group-title .savings.bubble{order:1!important;margin:0!important;}"
    + "}"
    + "@media (max-width:768px){"
    /* Mobile: pill straddles the top border of the box so the title, radio and
       price all share one line (Chris-approved fallback, 2026-08-07). */
    +   ".group-container{margin-top:16px!important;}"
    +   ".group-label{position:relative!important;overflow:visible!important;}"
    +   ".group-title{flex-direction:row!important;align-items:center!important;gap:8px!important;}"
    +   ".group-title .savings.bubble{position:absolute!important;top:-13px!important;left:14px!important;margin:0!important;z-index:2!important;}"
    + "}"
    /* Tight to the title, then a hairline separating it from the feature list (Figma). */
    /* Hairline is drawn by a pseudo-element that reaches back past the 26px indent so it
       starts at the radio/bullet edge and ends at the content edge: equal side padding. */
    + ".viktor-freq{position:relative!important;font-size:14px;line-height:1.3;color:#5b6b70;margin:0!important;margin-left:26px!important;padding:0 0 9px!important;text-align:left;border-bottom:0!important;}"
    + ".viktor-freq:after{content:''!important;position:absolute!important;left:-26px!important;right:0!important;bottom:0!important;height:0!important;border-bottom:1px solid rgba(0,0,0,.22)!important;}"
    /* Only pull the frequency line up when a per-serving line has made the price
       column two lines tall, so products without it never overlap. */
    /* Scoped to the SELECTED group only. Applying it to every group pulled 14px out of
       the collapsed Subscribe box (which has an empty .group-content) while the
       One-Time box has no .group-content at all, so the two heights diverged. */
    + "fieldset.viktor-has-pps .group-container--selected .group-content{margin-top:-14px!important;}"
    /* Collapsed rows: identical height regardless of which option is selected. */
    + ".group-topline{min-height:30px!important;}"
    /* The legend already labels the section; the duplicated selection name is dropped. */
    + "#skio-plan-picker-legend span{display:none!important;}"
    + ".group-topline{padding-bottom:0!important;margin-bottom:0!important;}"
    + ".group-content{margin-top:0!important;padding-top:0!important;}"
    + ".group-content.margin-left{margin-top:0!important;padding-top:0!important;}"
    + ".group-content-additional{margin-top:8px!important;}"
    /* Price column: keep Skio's own text nodes untouched (it is a lit component and
       re-renders them). Just force the <s> back to inline so it sits to the LEFT of
       the live price, and let the per-serving div be a block so it drops below. */
    + ".skio-price{display:block!important;text-align:right!important;white-space:nowrap!important;}"
    + ".skio-price s{display:inline!important;float:none!important;margin:0 6px 0 0!important;font-size:15px!important;font-weight:400!important;color:#9aa4a8!important;text-decoration:line-through!important;}"
    + ".viktor-pps{display:block!important;width:auto!important;text-align:right!important;font-size:12px!important;line-height:1.2!important;font-weight:400!important;margin-top:2px!important;white-space:nowrap!important;color:inherit!important;}"
    + ".group-container--selected .viktor-pps{color:#5b6b70!important;}"
    + "fieldset.viktor-single-freq select.selling-plan-dropdown{display:none!important;}"
    + "fieldset.viktor-single-freq .selling-plan-dropdown-label{display:none!important;}";
  /* Servings per pack, used only for the per-serving line. 0 = hide the line.
     Add new handles here when a product needs it. */
  var SERVINGS = LFCFG.v0;
  function apply(){
    var p=document.querySelector('skio-plan-picker');
    if(!p||!p.shadowRoot) return;
    var sr=p.shadowRoot;
    if(!sr.getElementById('viktor-skio-style')){
      var st=document.createElement('style'); st.id='viktor-skio-style'; st.textContent=CSS; sr.appendChild(st);
    }
    var lg=sr.getElementById('skio-plan-picker-legend');
    if(lg){
      /* Drop the trailing colon left behind once the selection name is hidden. */
      lg.childNodes.forEach(function(n){
        if(n.nodeType===3 && n.nodeValue && n.nodeValue.indexOf(':')>-1){
          var v=n.nodeValue.replace(/:\s*$/,'');
          if(n.nodeValue!==v){ n.nodeValue=v; }
        }
      });
    }
    var fs=sr.querySelector('fieldset');
    /* Build stamp so a screenshot can be traced to a specific deploy. */
    if(fs && fs.getAttribute('data-viktor-build')!=='v8'){ fs.setAttribute('data-viktor-build','v8'); }
    var sel=sr.querySelector('select.selling-plan-dropdown');
    if(fs&&sel){
      var single = sel.options.length<=1;
      fs.classList.toggle('viktor-single-freq', single);
      if(single){
        /* Static copy per Chris 2026-08-07. The option text already starts with
           "Delivery", so prefixing it produced "Delivery Delivery Every 28 Days". */
        var label='Delivered Monthly';
        var d=sr.querySelector('.viktor-freq');
        if(!d){ d=document.createElement('div'); d.className='viktor-freq'; sel.parentNode.insertBefore(d, sel); }
        if(d.textContent!==label){ d.textContent=label; }
      }
    }
    if(SERVINGS>0){
      sr.querySelectorAll('.skio-price').forEach(function(pr){
        /* Read the price from the Skio nodes ONLY. Reading pr.textContent included
           our own injected "Only $x / serving" line, so each pass divided the
           previous result again and it decayed to $0.00. */
        var txt='';
        pr.childNodes.forEach(function(n){
          if(n.nodeType===1 && n.classList && n.classList.contains('viktor-pps')) return;
          if(n.nodeType===1 && n.tagName==='S') return;
          txt += (n.textContent||'');
        });
        txt=txt.replace(/\s+/g,' ');
        var all=txt.match(/\$[0-9][0-9,]*(?:\.[0-9]{2})?/g);
        if(!all||!all.length) return;
        var live=parseFloat(all[all.length-1].replace(/[$,]/g,''));
        if(!(live>0)) return;
        var per=(live/SERVINGS);
        /* "Only" reads as a subscription value cue, so it is dropped on the
           one-time option (the group with no selling-plan dropdown). */
        var grp = pr.closest ? pr.closest('.group-container') : null;
        var gi  = grp && grp.querySelector('input.group-input');
        /* Belt and braces: Skio marks the one-time radio with id "one-time-..." and
           value "One time purchase". Either signal alone is enough. */
        var isOneTime = !!(gi && (/^one-time/.test(gi.id||'') || /one time/i.test(gi.value||'')))
                        || !!(grp && !grp.querySelector('select.selling-plan-dropdown'));
        var isSub = !isOneTime;
        var copy=(isSub?'Only $':'$')+per.toFixed(2)+' / serving';
        var el=pr.querySelector('.viktor-pps');
        if(!el){ el=document.createElement('div'); el.className='viktor-pps'; pr.appendChild(el); }
        if(el.textContent!==copy){ el.textContent=copy; }
        if(fs){ fs.classList.add('viktor-has-pps'); }
      });
    }
  }
  function boot(){
    var n=0, t=setInterval(function(){ apply(); if(++n>60) clearInterval(t); },250);
    document.addEventListener('change', function(){ setTimeout(apply,250); }, true);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();
